import React, {
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState
} from 'react';
import { generate } from 'short-uuid';
import { io } from 'socket.io-client';
import PropTypes from 'prop-types';

import { get } from '../utilities/configUtility';
import { getAuth } from '../utilities/axios';
import { useAuth } from './useAuth';

const NotificationsContext = createContext();

const NotificationsContextProvider = ({ children }) => {
	/* ====================== HOOKS ====================== */
	const [SocketIo, setSocketIo] = useState();

	const [notifications, setNotifications] = useState([
		// {
		// 	id: '1',
		// 	action: 'addMedia',
		// 	message: 'Ethan Soper added a media file',
		// 	timestamp: '11/20/2988'
		// }
		// {
		// 	id: '2',
		// 	action: 'addMedia',
		// 	message: 'Ethan Soper added a media file',
		// 	timestamp: '11/20/2988'
		// }
	]);
	const { isAuthenticated } = useAuth();

	/* ====================== VALIDATOR ====================== */

	/* ====================== EFFECTS ====================== */
	useEffect(() => {
		// Check for Notifications from API first, add them to notifications.
		// If a notification comes in, add it to the top of the list.
		// Notifications can only be dismissed by clicking the x, or the "clear all" button
	}, []);

	useEffect(() => {
		// console.log('Loading Notifications', auth);
		if (isAuthenticated) {
			const socketInstance = io(get('socketIO.host'), {
				auth: {
					token: getAuth()
				}
			});
			socketInstance.on('connect', () => {
				// console.log('SocketIo Connected');
				setSocketIo(socketInstance);
			});

			socketInstance.on('disconnect', () => {
				// console.log('SocketIo disconnected');
				setSocketIo(undefined);
			});
		} else {
			if (SocketIo) {
				SocketIo.disconnect();
			}
			setSocketIo(undefined);
		}
	}, [isAuthenticated]);

	useEffect(() => {
		if (SocketIo && SocketIo.connected) {
			// @INFO: Register the events here
			SocketIo.on('event:update', (event) => {});

			SocketIo.on('event:mediaUpload', (event) => {
				// @TODO: this should call to get media again to update red dots

				event.id = generate();

				const newNotifications = [...notifications];
				newNotifications.push(event);
				setNotifications(newNotifications);
			});
		}
	}, [notifications, SocketIo]);
	/* ====================== METHODS ====================== */
	const notificationsMarkAsViewed = (id) => {
		const newNotificationList = notifications.filter(
			(notification) => notification.id !== id
		);
		setNotifications(newNotificationList);

		// @TODO: Send to API that it was read
	};

	/* ====================== MEMO ====================== */
	const value = useMemo(
		() => ({
			isConnected: SocketIo !== undefined,
			notifications,
			notificationsMarkAsViewed
		}),

		[notifications, SocketIo]
	);

	/* ====================== RENDER ====================== */

	return (
		<NotificationsContext.Provider value={value}>
			{children}
		</NotificationsContext.Provider>
	);
};

NotificationsContextProvider.propTypes = {
	children: PropTypes.object
};

export const NotificationsProvider = NotificationsContextProvider;

export const useNotifications = () => {
	return useContext(NotificationsContext);
};
